<template>
  <div class="image-container">
    <!-- 骨架屏 -->
    <div v-if="!isLoaded && !isError" class="skeleton-image"></div>
    <!-- 加载成功的图片 -->
    <img v-if="isLoaded && !isError" :src="src" alt="" class="loaded-image"/>

    <!-- 加载失败的破碎图片 -->
    <div v-if="isError" class="broken-image">
      <div class="broken-image-icon">❌</div>
      <div>图片加载失败</div>
    </div>
    <!-- 隐藏的图片用于加载检测 -->
    <img v-if="prop.src" :src="src" alt="" @load="handleLoad" @error="handleError" style="display: none;"/>
  </div>
</template>

<script  setup>
import {defineProps, ref, watch} from "vue";
let prop = defineProps({
  src: {
    type: String,
    required: true
  }
})
const isLoaded = ref(false);
const isError = ref(false);
watch(() => prop.src, () => {
  isLoaded.value = false;
  isError.value = false;
});
const handleLoad = () => {
  isLoaded.value = true;
  isError.value = false;
};

const handleError = () => {
  isLoaded.value = false;
  isError.value = true;
};
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.skeleton-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 0;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.loaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
}
.broken-image {
  width: 100%;
  height: 100%;
  background: #ffebee;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #e53935;
}
.broken-image-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}
</style>
